module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAxIiBoZWlnaHQ9IjIxNyIgdmlld0JveD0iMCAwIDMwMSAyMTciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjMDAzODk3IiBkPSJNLjUuNWgzMDB2MjE2SC41Ii8+PHBhdGggZD0iTTg0LjUuNWg0OHYyMTZoLTQ4bS04NC0xMzJoMzAwdjQ4SC41IiBmaWxsPSIjRkZGIi8+PHBhdGggZD0iTTk2LjUuNWgyNHYyMTZoLTI0bS05Ni0xMjBoMzAwdjI0SC41IiBmaWxsPSIjRDcyODI4Ii8+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/svg/flag/cif-is.svg
// module id = Xs7a
// module chunks = 2